<template>
  <div class="register-container">
    <web-head
      :active="tab"
      @change="changeTab"
      @toDetailInfo="toDetailInfo"
    ></web-head>
    <div class="el-container type-page">
      <header class="el-header">
        <div class="circle extraCircle">
          1
          <p>填写基本信息</p>
        </div>
        <div class="line" :class="extraLine"></div>
        <div class="circle" :class="extraCircle">
          2
          <p>邮箱激活</p> 
        </div>
        <div class="line" :class="extraLine1"></div>
        <div class="circle" :class="extraCircle1">
          3
          <p>完善注企业资料</p>
        </div>
      </header>
      <!-- !isNextStep  isActivateEmail isDetailInfo-->
      <section class="el-main" v-if="!isNextStep">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="用户名">
            <el-input v-model="loginName" readonly=""></el-input>
            <!-- <p>该用户名用于登录，请谨慎填写</p> -->
          </el-form-item>
          <el-form-item label="姓名" prop="username">
            <el-input v-model="ruleForm.username"></el-input>
            <!-- <p>该用户名用于登录，请谨慎填写</p> -->
          </el-form-item>
           <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
            <!-- <p>该用户名用于登录，请谨慎填写</p> -->
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
            <!-- <p>作为登录帐号，填写未被注册的邮箱</p> -->
          </el-form-item>
          <!-- <el-form-item label="密码" prop="password" >
            <el-input type="password"  v-model="ruleForm.password" autocomplete="off"></el-input>
            <p>密码必须包含数字、字母，区分大小写，最短8位，区分大小写</p>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPassword">
            <el-input type="password" v-model="ruleForm.checkPassword" autocomplete="off"></el-input>
          </el-form-item> -->
          <el-form-item
            label="验证码"
            prop="captcha"
            style="width: 250px; height: 80px"
          >
            <el-input v-model="ruleForm.captcha"></el-input>
            <img :src="captchaPath" alt="" @click="getCaptcha" />
            <el-link @click="getCaptcha">换一张</el-link>
            <!-- <a @click="getCaptcha">换一张</a> -->
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="checked"
              >我同意并遵守上述的 《电子商务平台的服务协议》</el-checkbox
            >
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item> -->
        </el-form>
      </section>
      <section class="el-main-activate" v-if="isActivateEmail">
        <div class="main-top">
          <div class="email"><i class="iconfont icon-mail"></i></div>
          <div class="text">
            <p>感谢注册，确认邮件已发送至你的注册邮箱 :{{ ruleForm.email }}</p>
            <span>请进入邮箱查看邮件，并激活电子商务平台帐号。</span>
          </div>
        </div>
        <a :href="linkEmail" target="_blank"
          ><el-button type="success" @click="loginEmail">登录邮箱</el-button></a
        >
        <div class="main-buttom">
          <span>没有收到邮件？</span>
          <ol class="list">
            <li>
              请检查邮箱地址是否正确，你可以返回
              <el-link type="primary" @click="reWrite">重新填写</el-link>
            </li>
            <li>检查你的邮件垃圾箱</li>
            <li>
              若仍未收到确认，请尝试
              <el-link type="primary" @click="reSend">重新发送</el-link>
            </li>
          </ol>
        </div>
      </section>
      <section class="el-main-info" v-if="isDetailInfo">
        <div class="button">企业注册</div>
        <template>
          <p class="info">企业信息</p>
          <div class="hr-line"></div>
          <el-form label-width="100px" :model="infomation">
            <el-form-item label="企业名称">
              <el-input
                v-model="infomation.enterprise.enterpriseName"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业简介">
              <el-input
                v-model="infomation.enterprise.introduction"
                type="textarea"
                :rows="5"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <el-form-item label="官方网站">
              <el-input v-model="infomation.enterprise.website"></el-input>
              <span>确保用户可以在官方网站了解你的业务和功能</span>
            </el-form-item>
            <el-form-item label="管理员号码">
              <el-input
                v-model="infomation.enterprise.mainPersonMobile"
              ></el-input>
              <!-- <el-button type="info" plain>获取验证码</el-button> -->
              <span>请填写常用手机号码</span>
            </el-form-item>
            <!-- <el-form-item label="短信验证码">
                    <el-input v-model="personInfo.message"></el-input>
                </el-form-item> -->
                <div class="flex-row-center-end-space-between both">
            <el-form-item label="营业执照">
              <el-upload
                class="upload-demo"
                ref="uploadimg"
                :action="uploadUrl"
                :on-success="getImgUrl"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :data="{ dirName: Date.now() }"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList1"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                   <!-- 只能上传jpg/png文件，且不超过500kb -->
                  <!-- <div slot="tip" class="el-upload__tip">
                 
                </div> -->
                </div>
              </el-upload>
            </el-form-item>
            <div class="flex-row-center-end-space-between moban">
             <el-form-item label="法人模板">
              <el-upload
                class="upload-demo"
                ref="uploadimg"
                :action="uploadUrl"
                :on-success="getImgUrl1"
                :on-preview="handlePreview1"
                :on-remove="handleRemove1"
                :before-remove="beforeRemove1"
                :data="{ dirName: Date.now() }"
                multiple
                :limit="1"
                :on-exceed="handleExceed1"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div> -->
              </el-upload>
            </el-form-item>
            <a href="http://anhuiec.oss-cn-hangzhou.aliyuncs.com/1648862959218%2F90eb510f985a4440ad13a1a20a4f9932.docx">法人模板</a>
            </div>
            </div>
          </el-form>
        </template>
        <div class="hr-line"></div>
        <div class="info-finished">
          <el-button type="primary" @click="submitInfo">完成</el-button>
        </div>
      </section>
      <!-- <div class="hr-line"></div> -->
      <footer class="el-footer" v-if="isShowFooter">
        <!-- isShowFooter -->
        <el-button
          type="success"
          v-if="checked"
          @click="nextStep('ruleForm')"
          :loading="base_loading"

          >下一步</el-button
        >
        <el-button type="info" v-else>下一步</el-button>
      </footer>
      <!-- //弹窗 -->
       <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <div class="sda" v-for="(item, index) in sdsda" :key="index">
          <el-radio v-model="radio" :label="item">{{ item.enterpriseName }}</el-radio>
          <!-- <el-radio v-model="radio" label="2">备选项</el-radio> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="relevanceEnterprise(radio)"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <web-foot />
  </div>
</template>

<script>
import Head from "@wigets/head.vue";
import Foot from "@wigets/foot.vue";
import { loginOrRegister } from "@/utils/websocketLogin";
import { userInfos,getListByPhone,relevanceEnterprise } from "@apis/apis.js";
export default {
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
        callback(new Error("请输入正确的邮箱地址"));
      }
      callback();
    };
    const validatePass = (rule, value, callback) => {
      if (!/^[a-z0-9]+$/i.test(value)) {
        //密码只能由数字和字母组成
        callback(new Error("请输入符合要求的密码"));
      } else if (value.length < 8) {
        callback(new Error("密码不足8位"));
      } else {
        if (this.ruleForm.checkPassword !== "") {
          this.$refs.ruleForm.validateField("checkPassword");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dsdid:"",
      dialogVisible:false,
      loginNameCopy: "",
      radio:'0',
      sdsda:[],
      loginName: "",
      tab: null,
      uploadUrl: "https://new.anhuiec.com/api/file/open/upload",
      ruleForm: {
        username: "",
        email: "",
        password: "",
        phone:"",
        checkPassword: "",
        checkKey: "",//检查码
        captcha: "",//验证码
      },

      infomation: {
        user: {
          //个人信息
          name: "",
          phone: "",
          userType: 3, //用户类别 3:个人用户 1：企业用户
        },

        enterprise: {
          //企业信息
          enterpriseName: "",
          introduction: "",
          website: "",
          mainPersonMobile: "",
          businessLicense: null, //企业营业执照
          corporate: null, //企业营业执照
        },
      },

      //定时器设置60秒一次短信
      /* clickMessage:0,
      setIntervalMessage:'',//定时器的id
      getmessage:'短信验证',//发送验证码的按钮 */

      checked: false, //复选框
      captchaPath: "", //验证码图片路径
      isNextStep: false, //是否进入下一步
      isActivateEmail: false, //是否在第二步
      isDetailInfo: false, //是否进步注册第三步
      isShowFooter: true, //是否展示底部
      extraCircle: "",
      extraLine: "", //样式叠加
      extraCircle1: "",
      extraLine1: "", //样式叠加
      linkEmail: "", //点击登录邮箱跳转的网址
      color1: { backgroundColor: "#537cb4" }, //按钮的背景颜色
      color2: { backgroundColor: "" }, //按钮的背景颜色
      // personRegistation: true, //个人注册
      enterpriseRegistation: true, //企业注册
      rules: {
        //表单规则
        phone: [
          { required: true, message: "请输入用户手机号", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validateEmail, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      fileList: [], //上传附件
      fileList1: [], //上传附件
      base_loading: false, // 下一步按钮的加载阀
      // 当前页面下websocket实例
      ws: null,
    };
  },
  components: {
    "web-head": Head,
    "web-foot": Foot,
  },
  created() {
    this.loginNameCopy = sessionStorage.getItem("loginName");
    this.getUserInfo();
    this.getCaptcha(); //获取验证码
    // 开启websocket并且获取实例
    loginOrRegister("1", this.callback);
    this.initPage(); //初始化页面
  },
  mounted() {
    // this.getPicUrl()
    // this.websoketSendMsg()
    // this.initPage()//初始化页面
  },
  methods: {
    getListByPhone(){
      let phone = this.ruleForm.phone
      this.$ajaxGet(`${getListByPhone}?phone=${phone}`).then(res =>{
        console.log(res);
        if(res.data.data.length >=1){
          // getListByPhone
          this.sdsda = res.data.data
          this.dialogVisible = true

        }else{
           this.activateEmail();
        }
        // this.dsdid = res.data.data.id
      })
    },
    close(){
      this.dialogVisible = false
      this.radio =''
    },
    // 开启websocket的回调函数
    getUserInfo() {
      this.$ajaxGet(userInfos, null).then((res) => {
        console.log(res);
        if (res.data.code != 0) {
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + "，请重新刷新",
          });
        } else {
          this.loginName = res.data.data.loginName;
        }
      });
    },
    callback(instance) {
      console.log(instance);
      if (instance) {
        this.ws = instance;
      } else {
        this.toDetailInfo();
      }
    },
    websoketSendMsg() {
      this.$ajaxGet("/register/websoketSendMsg?userId=1").then((res) => {
        console.log("注册", res);
      });
    },
    changeTab(val) {
      this.tab = val;
    },
    //初始化页面
    initPage() {
      this.isNextStep = false;
      this.isShowFooter = true;
      this.isActivateEmail = false;
      this.isDetailInfo = false;
      this.extraCircle = "";
      this.extraLine = "";
      this.extraCircle1 = "";
      this.extraLine1 = "";
      this.ruleForm = {};
    },
    //获取验证码
    getCaptcha() {
      this.$ajaxGet("/sys/captcha").then(({ data }) => {
        if (data && data.code === 0) {
          this.ruleForm.checkKey = data.data.key;
          this.captchaPath = data.data.image;
        }
      });
    },
    reWrite() {
      //重新填写
      this.isNextStep = false;
      this.isShowFooter = true;
      this.isActivateEmail = false;
      this.extraCircle = "";
      this.extraLine = "";
    },
    reSend() {
      //重新发送并激活邮箱
      this.activateEmail();
    },
    //发送并激活邮箱
    activateEmail() {
      this.base_loading = true;
      const { username, email, captcha, checkKey } = this.ruleForm;
      this.$ajaxPost("/register/enterpriseRegister", {
        username,
        email,
        captcha,
        checkKey,
      })
        .then((res) => {
          console.log("注册第一步", res);
          this.base_loading = false;
          if (res.data.code === 201) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg,
            });
            return;
          } else {
            if (res.data.code === 500) {
              this.$message({
                title: "错误",
                type: "error",
                message: res.data.msg,
              });
              return;
            }
            if (res.data.code != 0) {
              this.$message({
                title: "错误",
                type: "error",
                message: res.data.msg + ",请重新刷新",
              });
              return;
            } else {
              this.isNextStep = true;
              this.isShowFooter = false;
              this.isActivateEmail = true;
              this.extraCircle = "extraCircle";
              this.extraLine = "extraLine";
              // 操作成功，下一步按钮加载动画结束
              this.$message({
                title: "绑定成功",
                type: "success",
                message: "绑定成功",
              });
            }
          }
        })
        .catch((err) => {
          this.base_loading = false;
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
    nextStep(formName) {
      this.getListByPhone() 
       loginOrRegister("1", this.callback);
      // return
      //点击下一步按钮并提交表单的回调
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.$message({
            title: "错误",
            type: "error",
            message: "请正确填写信息",
          });
        } else {
         
        }
      });
    },
    // personRegister() {
    //   //个人注册按钮的回调
    //   this.enterpriseRegistation = false;
    //   this.personRegistation = true;
    //   this.color1.backgroundColor = "#537cb4";
    //   this.color2.backgroundColor = "";
    //   this.infomation.user.userType = 3;
    // },
    // enterpriseRegister() {
    //   //企业注册按钮的回调
    //   this.enterpriseRegistation = true;
    //   this.personRegistation = false;
    //   this.color2.backgroundColor = "#537cb4";
    //   this.color1.backgroundColor = "";
    //   this.infomation.user.userType = 1;
    // },
    //登录邮箱按钮的回调
    loginEmail() {
      // console.log(this.ruleForm.email.split('@').slice(-1))
      this.linkEmail = `https://mail.${this.ruleForm.email
        .split("@")
        .slice(-1)}`;
    },
    //跳转到注册第三步
    toDetailInfo() {
      console.log("进入注册的第三步");
      this.extraCircle = "extraCircle";
      this.extraLine = "extraLine";
      this.extraCircle1 = "extraCircle";
      this.extraLine1 = "extraLine";
      this.isNextStep = true;
      this.isActivateEmail = false;
      this.isDetailInfo = true;
      this.isShowFooter = false;
      this.infomation.user.email = this.ruleForm.email;
    },
    //点击完成按钮发送请求
    submitInfo() {
      console.log(this.infomation.enterprise);
      this.infomation.user.openid = sessionStorage.getItem("openid");
      this.$ajaxPost(
        "/register/improveEnterpriseData",
        this.infomation.enterprise               
      ).then(({ data }) => {
        // console.log(res)
        if (data.code === 0) {
          this.ws.close();
          this.$message({
            title: "注册成功",
            type: "success",
            message: "注册成功",
          });
          this.$router.push("/");
        }
      });
      //新接口
      let name = this.ruleForm.username
      let email = this.ruleForm.email
      this.$ajaxPost(
        "/register/perfectUserData",
        {name,email }             
      ).then(({ data }) => {
        console.log(res)
        if (data.code === 0) {
          // this.ws.close();
          this.$message({
            title: "注册成功",
            type: "success",
            message: "注册成功",
          });
          this.$router.push("/");
        }
      });
    },
    //提交关联企业
    relevanceEnterprise(id){
      // console.log(id);
      // let id = id.id
        this.$ajaxGet(`${relevanceEnterprise}?enterpriseId=${id.id}`).then(res =>{
        console.log(res);
        if(res.data.data){
           this.$message({
            title: "绑定成功",
            type: "success",
            message: res.data.msg,
          });
          this.dialogVisible = false 
          this.$router.go(-1)
          return
        }else{

        }
        
        // this.sdsda = res.data.data
      })
    },
    //获取短信验证码
    /* getMbmessage(){
      let reg=/^1[23456789]\d{9}$/
      if(!reg.test(this.personInfo.number)){
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号码",
        })}else{
        //点击后60s之后才能获取信息
        this.clickMessage=60
        this.getmessage=`请在${this.clickMessage}s后重试`
        clearInterval(this.setIntervalMessage)
        this.setIntervalMessage=setInterval(() => {
          this.clickMessage--
          this.getmessage=`请在${this.clickMessage}s后重试`
          if(this.clickMessage==0){
            clearInterval(this.setIntervalMessage)
            this.getmessage=`短信验证`
          }
        }, 1000);
        //发送验证码
        this.$ajaxPost('/sms/sendMsg/open',{}, {phone:this.personInfo.number}).then(res => {
          console.log('短信验证码',res)
          if(res.data.code!=0){
            this.$message({
              title: "错误",
              type: "error",
              message: "网络错误，请重新刷新",
            })
          }
        }).catch(err => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: '确定',
            type: "error",
          })
        })
      }
    }, */

    //上传附件相关
    getImgUrl(response, file, fileList) {
      console.log(response, file, fileList);
      this.infomation.enterprise.businessLicense = response.data;
    },
    //上传附件相关1
    getImgUrl1(response, file, fileList1) {
      console.log(response, file, fileList1);
      this.infomation.enterprise.corporate = response.data;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleRemove1(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
      console.log(this.fileList);
    },
     handlePreview1(file) {
      
    },
    handleExceed(files, fileList) {
      console.log(files);
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`
      );
    },
    handleExceed1(files, fileList) {
      console.log(files);
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeRemove1(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //获取图片上传路径
    getPicUrl() {
      this.$ajaxPost("/image/upload/open", {}).then((res) => {
        console.log(res, "图片的上传路径");
      });
    },
    beforeDestroy() {
      this.ws.close();
    },
  },
};
</script>

<style lang='less' scoped>
.both{
  width: 900px;
}
.moban{
  // width: 108%;
  margin-bottom: 4px;
}
.moban a{
  margin-bottom: .3rem;
  margin-left: 10px;
}
.upload-demo{
  width: 216px;
}
.el-container {
  height: 100%;
  margin-top: 0.171874rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 9.023437rem;
  font-size: 0.171875rem;
  border: 0.008594rem solid rgb(219, 216, 216);
  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 1.375rem;
    .circle {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      width: 0.4125rem;
      height: 0.4125rem;
      border-radius: 50%;
      background-color: #c2c3c4;
      color: white;
      p {
        position: absolute;
        width: 1.289062rem;
        font-size: 0.120312rem;
        bottom: -0.214844rem;
        color: #c2c3c4;
      }
    }
    .extraCircle {
      background-color: #74d3af;
    }
    .line {
      margin: 0 0.171875rem;
      width: 3.4375rem;
      border-top: 4px solid #c2c3c4;
    }
    .extraLine {
      border-top-color: #74d3af;
    }
  }
  .el-main {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #ffffff;
    .demo-ruleForm {
      margin-left: 0.34375rem;
      margin-top: 0.257812rem;
      width: 35%;
      p {
        font-size: 0.120312rem;
        color: #c2c3c4;
        line-height: 20px;
        text-align: left;
        margin-top: 0.042969rem;
      }
      .el-link {
        cursor: pointer;
        transform: translate(240%, -150%);
      }
    }
  }
  .el-main-activate {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0.859375rem;
    width: 100%;
    height: 600px;
    background-color: #ffffff;
    .main-top {
      display: flex;
      align-items: center;
      .email {
        text-align: center;
        line-height: 0.515625rem;
        width: 0.515625rem;
        height: 0.515625rem;
        border-radius: 50%;
        background-color: #00aeef;
      }
      .text {
        margin-left: 0.085937rem;
        text-align: left;
        p {
          font-size: 0.154687rem;
        }
        span {
          font-size: 0.128906rem;
          color: #c2c3c4;
        }
      }
    }
    .el-button {
      margin: 20px 0;
      transform: translateX(-190%);
    }
    .main-buttom {
      transform: translateX(-25%);
      text-align: left;
      span {
        font-size: 14px;
        color: #c2c3c4;
      }
      .list {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .el-main-info {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    height: 7.834375rem;
    background-color: #ffffff;
    padding-top: 0.257812rem;
    padding-left: 0.429687rem;
    box-sizing: border-box;
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2.432031rem;
      height: 0.446875rem;
      color: #fff;
      border-radius: 0.214844rem;
      background-color: #537cb4;
      margin-left: 0.429687rem;
      margin-bottom: 0.300781rem;
      margin-top: 0.300781rem;
    }
    .hr-line-1 {
      position: relative;
      width: 90%;
      border-top: 0.008594rem solid rgb(219, 216, 216);
      &::after {
        position: absolute;
        top: 0;
        left: 0.171875rem;
        width: 0px;
        content: "";
        border-top: 0.257812rem solid #4878b3;
        border-left: 0.257812rem solid transparent;
        border-right: 0.257812rem solid transparent;
        border-bottom: 0.257812rem solid transparent;
      }
    }
    .hr-line-2 {
      position: relative;
      width: 90%;
      border-top: 0.008594rem solid rgb(219, 216, 216);
      &::after {
        position: absolute;
        top: 0;
        left: 124px;
        width: 0px;
        content: "";
        border-top: 0.257812rem solid #85ce61;
        border-left: 0.257812rem solid transparent;
        border-right: 0.257812rem solid transparent;
        border-bottom: 0.257812rem solid transparent;
      }
    }
    p {
      margin-bottom: 0.085937rem;
    }
    /* .info{
        transform: translateX(140%);
      } */
    .el-form {
      position: relative;
      text-align: left;
      width: 3.4375rem;
      margin-top: 0.34375rem;
      span {
        font-size: 0.128906rem;
        color: #c2c3c4;
      }
      .el-button {
        position: absolute;
        right: 0;
      }
    }
    .info-finished {
      width: 100%;
      height: 0.6875rem;
      position: relative;
      .el-button {
        position: absolute;
        left: 40%;
        top: 50%;
        margin: 0 auto;
      }
    }
    //上传文件相关
    .el-upload {
      position: relative;
      .el-button {
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
  .hr-line {
    width: 90%;
    border-top: 0.008594rem solid rgb(219, 216, 216);
  }
  .el-footer {
    position: relative;
    transform: translateY(-200%);
    width: 100%;
    height: 1.03125rem;
    background-color: #ffffff;
    .el-button {
      position: absolute;
      left: 1.375rem;
      top: 0.171875rem;
    }
  }
  /deep/.el-dialog__body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    // margin-top: 10px;
  }
  /deep/.el-radio{
    margin-top: 10px;
  }
}
</style>